import PageModal from './PageModal'

export default PageModal
